import React from "react";

// Version: 1.1 - Connected lines to edge using isLast prop
const OfferStep = ({ stepNumber, content, stepIndex, onClick, isClickable = false, isLast = false }) => {
  const isActive = stepIndex === stepNumber;

  return (
    <div
      className={`relative flex-1 min-w-[90px] md:min-w-0 flex flex-col items-center justify-center h-[50px] ${isClickable ? "cursor-pointer" : "cursor-default"
        }`}
      onClick={isClickable ? () => onClick?.(stepNumber) : undefined}
    >
      {/* Progress line at the TOP - starts from left with gap only between steps, NOT at the ends */}
      <div
        className={`absolute top-0 left-0 ${isLast ? 'right-0' : 'right-[8px]'} h-[4px] ${stepNumber <= stepIndex ? "bg-[#00ADEF]" : "bg-[#F2F2F2]"
          }`}
      />

      {/* Text below the line */}
      <p
        className={`text-[12px] md:text-[14px] font-[500] font-poppins mt-3 px-2 text-center ${isActive ? "text-[#00ADEF]" : "text-[#767676]"
          }`}
      >
        {content}
      </p>
    </div>
  );
};

export default OfferStep;
